import * as React from 'react';
import classNames from 'classnames';
import { Popup } from 'rc-tooltip';
import { ConfigContext } from '../config-provider';
import useStyle from './style';
import { getRenderPropValue } from '../_util/getRenderPropValue';
export const getOverlay = (prefixCls, title, content) => {
    if (!title && !content)
        return undefined;
    return (React.createElement(React.Fragment, null,
        title && React.createElement("div", { className: `${prefixCls}-title` }, getRenderPropValue(title)),
        React.createElement("div", { className: `${prefixCls}-inner-content` }, getRenderPropValue(content))));
};
export default function PurePanel(props) {
    const { prefixCls: customizePrefixCls, className, placement = 'top', title, content, children, } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const [wrapSSR, hashId] = useStyle(prefixCls);
    return wrapSSR(React.createElement("div", { className: classNames(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className) },
        React.createElement(Popup, Object.assign({}, props, { className: hashId, prefixCls: prefixCls }), children || getOverlay(prefixCls, title, content))));
}
